import { createContext, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { publicRoutes } from '@shared/constants/publicRoutes'
import { UserService } from './service'

export const UserServiceContext = createContext<UserService | null>(null)

export const useUserService = (): UserService | null => {
	const context: UserService | null = useContext(UserServiceContext)
	const location = useLocation()
	const isPublicRoute = publicRoutes.includes(location.pathname)

	if (!context && !isPublicRoute) {
		throw new Error(
			'useUserService must be used within a UserServiceContextProvider and only on protected routes.'
		)
	}
	return context
}
